// Instance
import { addressFinderInstance } from "@/app/apis/main/address-finder/_connection/address-finder-connection-api.js";

export default class AddressFinderAPI {
    constructor() {
        this.axios = addressFinderInstance;
    }

    /**
     * @param {*} targetFile
     * @return - (string) ex. ?q=blah123&f_formReportId=1&f_statusId=3&sortBy=title&desc=true&page=1&limit=20
     */
    reusableAPIMethod(targetFile) {
        return "test";
    }
}
